export const columns = [
  { id: 'email', label: 'Emails', minWidth: 250 },
  { id: 'type', label: 'Tipo', minWidth: 100 },
  { id: 'updatedAt', label: 'Data de atualização', minWidth: 200 },
  { id: 'actions', label: 'Ações', minWidth: 50 }
]
